<template>
  <div>
    <vue-element-loading :active="loading_addresses" />
    <b-row v-if="addresses && getUuidPatientSelected">
      <b-col class="mt-3" cols="12" md="4" v-for="(address, index) in addresses" :key="index">
        <div class="box-address mtb-2 p-4">
          <div class="box-address-title mb-3">
            {{ address.name }}
            <div class="address-main" v-if="address.is_main">{{ $t('addresses.main') }}</div>
          </div>
          <div v-if="address.name" class="box-address-data">{{ address.address }}</div>
          <div v-if="address.town" class="box-address-data">{{ address.town }}</div>
          <div v-if="address.colony" class="box-address-data">{{ address.colony }}</div>
          <div v-if="address.postal_code" class="box-address-data">{{ address.postal_code }}</div>
          <div v-if="address.mobile" class="box-address-data">{{ address.country }}</div>
          <div v-if="address.mobile" class="box-address-data">{{ address.mobile }}</div>
          <b-row class="mt-2">
            <b-col class="mb-2 mr-3" cols="6" md="4">
              <b-button
                variant="primary-b"
                @click="routeTo({ name: 'useraddressedit', params: { aUuid: address.uuid, pt_uuid: getUuidPatientSelected}})"
              >{{ $t('addresses.update') }}</b-button>
            </b-col>
            <b-col class="mb-2 ml-3" cols="6" md="4">
              <b-button
                v-b-modal.modalDeleteAddress
                variant="secondary"
                @click="address_to_delete=address"
              >{{ $t('addresses.remove') }}</b-button>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col cols="12" md="3">
        <b-button
          class="mt-5"
          variant="primary"
          size="xl"
          @click="routeTo({ name: 'useraddressnew' })"
        >{{ $t('addresses.add_address') }}</b-button>
      </b-col>
    </b-row>

    <!-- Modal Component -->
    <b-modal
      id="modalDeleteAddress"
      ref="modal"
      :title="$t('addresses.help_delete')"
      @ok="deleteAddress(address_to_delete)"
    ></b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      addresses: [],
      loading_addresses: true,
      address_to_delete: null,
    };
  },
  computed: {
    ...mapGetters("naturalperson", ["getUuidPatientSelected"]),
  },
  watch: {
    getUuidPatientSelected: function() {
      this.loadAddresses();
    },
  },
  created() {
    this.loadAddresses();
  },
  methods: {
    routeTo(route) {
      this.$router.push(route);
    },
    loadAddresses: function() {
      this.loading_addresses = true;
      if (this.getUuidPatientSelected) {
        this.$store
          .dispatch("naturalperson/REQUEST_ADDRESSES", {
            pt_uuid: this.getUuidPatientSelected,
          })
          .then(
            response => {
              this.addresses = response.data.results;
              this.loading_addresses = false;
            },
            err => {
              this.$sentry({ capture: err });
              this.mnotify_error({
                text: this.$t("addresses.error.address_retrieve_error"),
              });
            }
          );
      }
    },
    deleteAddress: function(address) {
      this.$store
        .dispatch("naturalperson/DELETE_ADDRESS", {
          pt_uuid: this.getUuidPatientSelected,
          a_uuid: address.uuid,
        })
        .then(
          () => {
            this.loadAddresses();
            this.mnotify_success({
              text: this.$t("addresses.deleted_address"),
            });
          },
          err => {
            if (err.response.data.includes("MainAddressUndeletable")) {
              this.mnotify_error({
                text: this.$t("addresses.error.main_address_delete_error"),
              });
            } else {
              this.$sentry({ capture: err });
              this.mnotify_error({
                text: this.$t("addresses.error.address_delete_error"),
              });
            }
          }
        );
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        addresses: {
          add_address: "Add address",
          update: "Update",
          main: "Main",
          remove: "Remove",
          help_delete: "Are you sure you want to delete the address?",
          deleted_address: "Address deleted",
          error: {
            address_retrieve_error: "Cannot retrieve address",
            address_delete_error: "Cannot delete address",
            main_address_delete_error: "Cannot delete main address",
          },
        },
      },
    },
  },
};
</script>
<style scoped lang="scss">
.box-address {
  border: 1px solid $grey4-color;
}

.box-address-title {
  font-size: $font-size-medium * 1.1;
  color: $text-main-color;
  border-bottom: 1px solid #f0f0f0;
  text-transform: uppercase;
}

.box-address-data {
  font-size: $font-size-default;
  color: $grey3-color;
  line-height: 2rem;
}
.address-main {
  font-size: $font-size-default;
  float: right;
  color: $corp-color1;
  text-transform: capitalize;
}
</style>
